import { useContext } from 'react';
import DocumentsContext from '../../../../../providers/Documents/Documents.context';
import Button from '../../../../../components/Button';
import './Home.styles.scss';

function Home() {
  const { documents, downloadDocument } = useContext(DocumentsContext);

  return (
    <div className="home-page">
      <div className="content-container">
        <div className="page-header">
          <p className="page-title">Download documents</p>
        </div>
        {!!documents?.length && (
          <ul className="res-card">
            {documents.map((doc) => (
              <li key={doc.fileKey}>
                <Button onClick={() => downloadDocument(doc)}>
                  {doc.fileName}
                </Button>
                <span>expires in {doc.downloadExpirationDays} days</span>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}

export default Home;
